import { render, staticRenderFns } from "./reservation-table.vue?vue&type=template&id=6a6ac338&scoped=true&"
import script from "./reservation-table.vue?vue&type=script&lang=js&"
export * from "./reservation-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ac338",
  null
  
)

export default component.exports